var DeliveryTimeCalculator = function (dateFormat, now) {
	var dates = [];
	var noWorkRules = [];
	var periods = [];

	var getEnrichedDay = function (date, dayIndex, periodName, periodConfig) {
		var key = periodName;
		var returnValue = { key: periodName, originalKey: periodName, date: moment(date) };

		if (periodConfig != null && periodConfig instanceof Object) {
			Object.keys(periodConfig).forEach(function (_key) {
				if (['key', 'date', 'formatted'].indexOf(_key) != -1)
					throw new Error('Das Überschreiben der configattribute "key", "date" und "formatted" ist nicht erlaubt"');

				returnValue[_key] = periodConfig[_key];
			});
		}

		noWorkRules.forEach(function (noWorkRule) {
			var isNoWorkday;
			try{
				isNoWorkday = noWorkRule.rule(returnValue, dayIndex);
			}
			catch(e){
				throw new Error('NoWorkKule "' + noWorkRule.name + '" wirft eine Exception: ' + e);
			}
			if (isNoWorkday)
				key = noWorkRule.name;
		});

		returnValue.key = key;
		returnValue.formatted = key + ' ' + date.format(dateFormat);

		return returnValue;
	}
	var isAWorkday = function (day, dayIndex) {
		var isWorkday = !noWorkRules.some(function (noWorkRule, i, array) {
			return noWorkRule.rule(day, dayIndex);
		});

		return isWorkday;
	}

	var getLastDate = function (periodnames) {
		if (dates.length == 0)
			return moment(now);

		var date = moment(dates[dates.length - 1].date);
		//wenn schon Einträge vorhanden sind, muss vom letzten Datum 1 Tag hinzuaddiert werden. Sonst fängt die Periode am letzten Tag der alten Periode an.
		date.add(1, 'days');

		return date;
	}

	var executePeriod = function(workingDays, periodName, periodConfig){
		if (workingDays < 1)
				return;

			var i = 0;
			var _workingDays = workingDays;
			var deliveryDate = getLastDate();

			while (i < _workingDays) {
				var currentDate = moment(deliveryDate).add(i, 'days');

				var day = getEnrichedDay(currentDate, dates.length, periodName, periodConfig);

				if (!isAWorkday(day, dates.length))
					_workingDays++;

				dates.push(day);

				i++;
			}
			return _workingDays;
	}

	return {
		toArray: function () {
			return dates;
		},
		addPeriod: function (workingDays, periodName, periodConfig) {
			periods.push([workingDays,periodName,periodConfig]);
		},
		getPeriods: function () {
			var periods = Array.prototype.slice.call(arguments)

			if (periods.length == 0) {
				return dates;
			}

			var daysOfPeriod = [];
			dates.forEach(function (day) {
				if (periods.indexOf(day.key) != -1) {
					daysOfPeriod.push(day);
				}
			});
			return daysOfPeriod;
		},
		reset: function () {
			dates = [];
			noWorkRules = [];
			periods = [];
		},
		lastDateOfPeriod: function (periods) {
			var args = Array.prototype.slice.call(arguments);

			var lastDate = undefined;
			dates.forEach(function (elem) {
				if (args.indexOf(elem.key) != -1)
					lastDate = elem;
			});
			return lastDate;
		},
		addNoWorkRule: function (name, noWorkRule) {
			noWorkRules.push({
				rule: noWorkRule,
				name: name
			});
		},
		calculateDates: function (require) {
			periods.forEach(function(period){
				executePeriod(period[0],period[1],period[2]);
			});

			var shippingDate = this.lastDateOfPeriod('PRODUKTION', 'PRODUKTION-ADDITIONAL');
			var deliveryDate = this.lastDateOfPeriod('VERSAND') || shippingDate;

			var returnValues = {
				shippingDate: shippingDate.date,
				deliveryDate: deliveryDate.date,
				initialDate: moment(now),
				initialDateFormatted: moment(now).format(dateFormat),
				initialAdditionalDays: require.additionalDays,
				initialProductionDays: require.durationOfProduction,
				initialShippingTime: require.shippingTime,
				shippingDateFormatted: shippingDate.date.format(dateFormat),
				deliveryDateFormatted: deliveryDate.date.format(dateFormat),
				steps: this.getPeriods(),
				daysWithShipping: this.getPeriods().length,
				productionDaysWithoutShipping_ignoreNoworkdays: this.getPeriods('PRODUKTION', 'PRODUKTION-ADDITIONAL').length,
				productionDaysWithShipping_ignoreNoworkdays: this.getPeriods('PRODUKTION', 'PRODUKTION-ADDITIONAL','VERSAND').length,
			};
			return returnValues;
		}
	}
}

export default DeliveryTimeCalculator;


// WEBPACK FOOTER //
// ./src/scripts/op/productionTimeCalculation/DeliveryTimeCalculator.es6.js